var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"robotmap",on:{"click":_vm.hidCompShow}},[_c('ve-bmap',{attrs:{"settings":_vm.chartSettings,"after-set-option-once":_vm.afterSet,"series":_vm.chartSeries,"tooltip":_vm.chartTooltip,"width":"100%","height":"100%"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c8417382","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/robotMap.vue
// module id = null
// module chunks = 